import React from 'react';

const SHOWN_COHORTS = 2;

// Cohorts using the course: the first two, then "+N more" (all in the tooltip).
function CohortLine({ cohortNames }) {
  if (!cohortNames.length) {
    return <p className="text-xs text-gray-400">No cohort yet</p>;
  }
  const shown = cohortNames.slice(0, SHOWN_COHORTS).join(', ');
  const more = cohortNames.length - SHOWN_COHORTS;
  return (
    <p
      className="text-xs text-gray-500 line-clamp-2"
      title={cohortNames.join(', ')}
    >
      Cohorts: {shown}
      {more > 0 && ` +${more} more`}
    </p>
  );
}

// `labelled` adds the name and, once loaded, the cohorts (the Courses
// page); without it the card shows only the image, as before.
function Course({ image, name, labelled, cohortNames }) {
  return (
    <div className=" rounded-md py-2 bg-white">
      <div className="flex items-center justify-center">
        <img src={image} alt="" className="h-32  object-fill" />
      </div>
      {labelled && (
        <div className="space-y-0.5 px-3 pt-2">
          <p
            className="truncate text-sm font-medium text-gray-900"
            title={name}
          >
            {name}
          </p>
          {Array.isArray(cohortNames) && (
            <CohortLine cohortNames={cohortNames} />
          )}
        </div>
      )}
    </div>
  );
}

export default Course;
